import { Injectable } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  pageTitle?: string;
  scrollBottom = new Subject();

  constructor(private title: Title, private analytics: AngularFireAnalytics) {}

  setPageTitle(title: string): void {
    this.pageTitle = title;
    this.title.setTitle(`gleemo · ${title}`);
  }

  logEvent(name: string, options?: any): void {
    this.analytics.logEvent(name, options);
  }
}
